import styled from "@emotion/styled";
import { QuestsModel } from "../../../../../Models/Quests/Quests.Model";
import React from "react";
import { QuestModelHelper } from "../../../../../Models/Quests/Helpers/QuestModel.Helper";
import { Spinner } from "@swivl-mono/ui";


interface WrapperProps {
    isAdding: boolean;
}
const Wrapper = styled.div<WrapperProps>`
position: relative;
padding: 12px 12px 12px 0;
  transition: all 0.3s ease;

 width: 10px;

 &.isAdding, 
  &:hover {
    width: 288px;
    
    .addButton {
        opacity: 1;
      }
  }

 

  cursor: pointer;




`;

// const AddQuest = styled.div`
//     background-color: #F0ECE9;
//     flex:1; 
//     border: 2px dashed #C3BCB9;
//     border-radius: 8px;
//     margin-right: 12px;
//     height:45px;
//     cursor: pointer;
//     `;

    const AddButton = styled.div`
    transition: all 0.2s ease;

    opacity: 0;
    top:20px;
    right:10px;
    position: absolute;
    min-height: 80vh;
    width: 258px;

    font-size: 14px;
    background-color: #F0ECE9;
    flex:1; 
    border: 2px dashed #C3BCB9;
    height:45px;
    border-radius: 8px;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color:#413B38;

    &:hover {
        background-color: #FDF6F3;
    }
    $:active {
        color:#5E5450;
        border-color: #5E5450;
    }

    `;



export default function AddQuestButtons() {
    const [isAdding, setIsAdding] = React.useState(false)
    const addJourneyClicked = async () => {
        if (isAdding) { return }
        setIsAdding(true)
        const journey = QuestModelHelper.newJourney("New Journey")
        await QuestsModel.createJourney(journey)
        setIsAdding(false)
    }
    return <Wrapper className={isAdding ? "AddQuestButtons isAdding" :"AddQuestButtons"} isAdding={isAdding}>
        <AddButton className="addButton" onClick={addJourneyClicked}>
            {isAdding ? <Spinner /> : "+ New Journey"}
            </AddButton>

    </Wrapper>
}